

import React, { useContext } from 'react'
import { SkyInformationPopover } from './SkyPopover';
import { FirebaseService, FirebaseConfigKey } from '../../../services/FirebaseService';
import { InsurancePurchaseContextStore, INSURANCE_CONTEXT_ACTIONS } from '../../../context/InsuracePurchaseContext'
import { PolicyHullExtensionContextStore, ACTIONS } from '../../../context/PolicyHullExtensionContext';
import { useLocation, useParams } from 'react-router-dom';
import { InsuranceBillingPeriod } from '../../../models/insurance-models/InsuranceBillingPeriodModel';
var classNames = require('classnames')

export const IndoorCoveragePopover = (props) => {
  const location = useLocation()
  const insurancePurchaseContext = useContext(InsurancePurchaseContextStore)
  
  return (
      <SkyInformationPopover eventId={'indoor-coverage'}>
            <div className="text-small">Indoors coverage could be added with an additional premium.</div>
            <div className="text-small">Indoor flights will be covered as long as the drone is not flying over people.</div>
        </SkyInformationPopover>
  );
}